module.exports = __webpack_public_path__ + "img/gongdanzongshu.302630dc.png";